import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.js';
import { SignedInAs } from '../components/SignedInAs.js';

type Vendor = { id: string; name: string; slug: string };

/** Vendor-admin view, scoped server-side to their own vendors. Results land in build step 4. */
export function VendorDashboardPage() {
  const vendors = useQuery({
    queryKey: ['vendors'],
    queryFn: () => api.get<Vendor[]>('/admin/vendors'),
  });

  return (
    <main>
      <h1>Dashboard</h1>
      <SignedInAs />

      {vendors.isPending && <p>Loading…</p>}
      {vendors.data && vendors.data.length === 0 && (
        <p>You do not have dashboard access to any company yet.</p>
      )}
      {vendors.data?.map((vendor) => (
        <section key={vendor.id}>
          <h2>{vendor.name}</h2>
          <p>Completion tracking, charts and CSV export land in build step 4.</p>
        </section>
      ))}
    </main>
  );
}
